<template>
  <v-card>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="4" class="d-flex flex-column">
            <activity-revenue />
          </v-col>

          <v-col cols="12" sm="4" class="d-flex flex-column">
            <billed-revenue />
          </v-col>

          <v-col cols="12" sm="4" class="d-flex flex-column">
            <subscriptions-m-m-r />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12">
            <billed-revenue-graph></billed-revenue-graph>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12">
            <activity-revenue-graph></activity-revenue-graph>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import ActivityRevenue from "@/components/FinancialDashboard/ActivityRevenue";
import BilledRevenue from "@/components/FinancialDashboard/BilledRevenue";
import BilledRevenueGraph from "@/components/FinancialDashboard/BilledRevenueGraph";
import SubscriptionsMMR from "@/components/FinancialDashboard/SubscriptionsMMR";
import ActivityRevenueGraph from "@/components/FinancialDashboard/ActivityRevenueGraph";
export default {
  name: "Dashboard",
  title: "Financial Dashboard",

  components: {
    ActivityRevenue,
    BilledRevenueGraph,
    BilledRevenue,
    SubscriptionsMMR,
    ActivityRevenueGraph
  }
};
</script>
